import { graphql } from "react-apollo";
import gql from "graphql-tag";
import format from "date-fns/format";

import React from "react";
import { connect } from "react-redux";

import { apolloClient } from "../apollo/apollo-client";

import * as actions from "../actions/actions";
let Loading = require("./loading");
let number_with_commas = require("./../legacy/helpers/number_with_commas")
    .default;

const ITEMS_PER_PAGE = 100;

class DownloadHistory extends React.Component {
    constructor(props) {
        super(props);
        this.props.getCurrentUser();

        this.offset = 0;

        this.state = {
            previousDisabled: true,
            nextDisabled: false,
            showDownloadId: null
        };
    }

    componentDidMount() {
        window.addEventListener("mousedown", this.pageClick.bind(this), false);
    }

    downloadType(download) {
        let licenseImage = (
            <a
                href={`/${this.props.username}/settings/icon-history/${download.id}`}
                title={"View License PDF"}
                target="_blank"
            >
                <img
                    src={require("../../img/features/icon_history/license.png")}
                    style={{
                        width: "24px",
                        height: "24px",
                        marginRight: "8px"
                    }}
                />
            </a>
        );

        let downloadType;
        switch (download.downloadType) {
            case "public domain":
                downloadType = <span>Public Domain</span>;
                break;
            case "attribution":
                downloadType = <span>None, must attribute</span>;
                break;
            case "prepaid":
                downloadType = <span>Via Prepaid Purchase</span>;
                break;
            case "purchase":
                downloadType = (
                    <span style={{ display: "flex", alignItems: "center" }}>
                        {licenseImage}
                        Via A-La-Carte Purchase
                    </span>
                );
                break;
            case "FREE":
                downloadType = <span>None, must attribute</span>;
                break;
            case "LARGE":
                downloadType = <span>Via A-La-Carte Purchase</span>;
                break;
            case "FULL_RES":
                downloadType = <span>Via A-La-Carte Purchase</span>;
                break;
            default:
                // premium, adobe_plugin, office_plugin, gsuite_plugin, macapp
                // check to see if license is PD which is license 2
                if (download.icon && download.icon.licenseId == 2) {
                    downloadType = <span>Public Domain</span>;
                } else {
                    downloadType = (
                        <span style={{ display: "flex", alignItems: "center" }}>
                            {licenseImage}
                            Via Subscription
                        </span>
                    );
                }
                break;
        }

        return downloadType;
    }

    goToPage(page, e) {
        e.preventDefault();
        this.offset = (page - 1) * 100;
        this.props.loadMoreDownloads(this.offset);
    }

    pageClick(e) {
        if (
            e.target.parentNode &&
            e.target.parentNode.className === "view-more-link"
        ) {
            this.setState({
                showDownloadId: e.target.getAttribute("data-download")
            });
        } else if (document.querySelector(".action-menu") !== null) {
            if (
                document.querySelector(".action-menu").contains(e.target) ==
                false
            ) {
                this.setState({ showDownloadId: null });
            }
        }
    }

    purchaseIcon(e) {
        e.preventDefault();
    }

    render() {
        if (this.props.downloadHistory && this.props.user !== undefined) {
            let downloads = this.renderDownloads(),
                nounProAdvert = this.renderNounProAdvert(),
                pagination = this.renderPagination();

            return (
                <section>
                    {nounProAdvert}
                    <h3 className="font-xlarge weight-light margin-t-xl">
                        Download History
                    </h3>
                    <p>
                        Every time you use an image, it is recorded in this
                        list.
                    </p>
                    <table className="billing-history-table">
                        <tbody>
                            <tr className="header-row row">
                                <th className="col-xs-3">Date of use</th>
                                <th className="col-xs-4">Image used</th>
                                <th className="col-xs-4">
                                    Royalty—free License
                                </th>
                                <th className="col-xs-1" />
                            </tr>
                            {downloads}
                        </tbody>
                    </table>
                    {pagination}
                </section>
            );
        } else {
            return <Loading />;
        }
    }
    renderNounProAdvert() {
        let advert;

        if (this.props.user.has_premium_account === false) {
            advert = (
                <div
                    className="row"
                    style={{ borderBottom: "1px solid #BABABA" }}
                >
                    <div className="col-xs-8 padding-t-xl padding-b-xl">
                        <h3 className="font-xlarge weight-medium">
                            Get unlimited royalty—free licenses with NounPro
                        </h3>
                        <p>
                            Plus a whole lot more!{" "}
                            <a href="/pricing/" className="text-link">
                                Learn More
                            </a>
                        </p>
                    </div>
                    <div className="col-xs-4 margin-t-xxl">
                        <a
                            href="/accounts/upgrade/billing/"
                            className="button blue small font-small"
                            title="Start NounPro"
                        >
                            <span>Start NounPro</span>
                        </a>
                    </div>
                </div>
            );
        }

        return advert;
    }

    renderActionMenu(download) {
        let actionMenu;
        if (download.id === this.state.showDownloadId) {
            switch (download.downloadType) {
                case "FREE":
                case "LARGE":
                case "FULL_RES":
                    if (download.photo.active) {
                        actionMenu = (
                            <ul className="action-menu">
                                <li>
                                    <a
                                        href={`/photo/${download.photo.slugWithId}/`}
                                        title={"View Photo"}
                                        target="_blank"
                                    >
                                        View Photo
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={`/photo/${download.photo.slugWithId}/`}
                                        title={"Download Photo"}
                                        target="_blank"
                                    >
                                        Download Photo
                                    </a>
                                </li>
                            </ul>
                        );
                    }
                    break;
                case "public domain":
                    if (download.icon.isActive) {
                        actionMenu = (
                            <ul className="action-menu">
                                <li>
                                    <a
                                        href={`/icon/${download.icon.id}/`}
                                        title={"View Icon"}
                                        target="_blank"
                                    >
                                        View Icon
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={`/icon/${download.icon.id}/`}
                                        title={"Download Icon"}
                                        target="_blank"
                                    >
                                        Download Icon
                                    </a>
                                </li>
                            </ul>
                        );
                    }
                    break;
                case "attribution":
                    let purchaseIconLink;

                    if (this.props.user.has_premium_account === false) {
                        purchaseIconLink = (
                            <li>
                                <a
                                    href={`/icon/${download.icon.id}/?purchase=true`}
                                    title={"Purchase License"}
                                    target="_blank"
                                >
                                    Purchase License
                                </a>
                            </li>
                        );
                    }
                    if (download.icon.isActive) {
                        actionMenu = (
                            <ul className="action-menu">
                                <li>
                                    <a
                                        href={
                                            "https://creativecommons.org/licenses/by/3.0/"
                                        }
                                        title={"How to Attribute"}
                                        target="_blank"
                                    >
                                        How to Attribute
                                    </a>
                                </li>
                                {purchaseIconLink}
                                <li>
                                    <a
                                        href={`/icon/${download.icon.id}/`}
                                        title={"View Icon"}
                                        target="_blank"
                                    >
                                        View Icon
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={`/icon/${download.icon.id}/`}
                                        title={"Download Icon"}
                                        target="_blank"
                                    >
                                        Download Icon
                                    </a>
                                </li>
                            </ul>
                        );
                    }
                    break;
                case "purchase":
                    if (download.icon.isActive) {
                        actionMenu = (
                            <ul className="action-menu">
                                <li>
                                    <a
                                        href={`/${this.props.username}/settings/icon-history/${download.id}`}
                                        title={"View License PDF"}
                                        target="_blank"
                                    >
                                        View License PDF
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={`/${this.props.username}/settings/invoices/`}
                                        title={"View Invoices"}
                                        target="_blank"
                                    >
                                        View Invoices
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={`/icon/${download.icon.id}/`}
                                        title={"View Icon"}
                                        target="_blank"
                                    >
                                        View Icon
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={`/icon/${download.icon.id}/`}
                                        title={"Download Icon"}
                                        target="_blank"
                                    >
                                        Download Icon
                                    </a>
                                </li>
                            </ul>
                        );
                    } else {
                        actionMenu = (
                            <ul className="action-menu">
                                <li>
                                    <a
                                        href={`/${this.props.username}/settings/icon-history/${download.id}`}
                                        title={"View License PDF"}
                                        target="_blank"
                                    >
                                        View License PDF
                                    </a>
                                </li>
                            </ul>
                        );
                    }
                    break;
                default:
                    let licenseLink;

                    if (download.icon.licenseId !== 2) {
                        licenseLink = (
                            <li>
                                <a
                                    href={`/${this.props.username}/settings/icon-history/${download.id}`}
                                    title={"View License PDF"}
                                    target="_blank"
                                >
                                    View License PDF
                                </a>
                            </li>
                        );
                    }

                    if (download.icon.isActive) {
                        actionMenu = (
                            <ul className="action-menu">
                                {licenseLink}
                                <li>
                                    <a
                                        href={`/icon/${download.icon.id}/`}
                                        title={"View Icon"}
                                        target="_blank"
                                    >
                                        View Icon
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={`/icon/${download.icon.id}/`}
                                        title={"Download Icon"}
                                        target="_blank"
                                    >
                                        Download Icon
                                    </a>
                                </li>
                            </ul>
                        );
                    } else {
                        actionMenu = (
                            <ul className="action-menu">{licenseLink}</ul>
                        );
                    }
                    break;
            }
        }

        return actionMenu;
    }

    renderUseSource(downloadType) {
        let sourceImageUrl, sourceImageTitle;

        switch (downloadType) {
            case "macapp":
                sourceImageUrl = require("../../img/features/icon_history/use_mac_app.png");
                sourceImageTitle = "Used from Noun Project for Mac";
                break;
            case "adobe_plugin":
                sourceImageUrl = require("../../img/features/icon_history/use_creative_cloud.png");
                sourceImageTitle = "Used from Adobe Add-on";
                break;
            case "office_plugin":
                sourceImageUrl = require("../../img/features/icon_history/use_office.png");
                sourceImageTitle = "Used from Microsoft Office Add-in";
                break;
            case "gsuite_plugin":
                sourceImageUrl = require("../../img/features/icon_history/use_google.png");
                sourceImageTitle = "";
                break;
            default:
                // premium, purchase, public domain, attribution
                sourceImageUrl = require("../../img/features/icon_history/use_download.png");
                sourceImageTitle = "Downloaded from nounproject.com";
                break;
        }

        let imgHtml = (
            <img
                src={sourceImageUrl}
                style={{ width: "24px", height: "24px", marginRight: "8px" }}
                title={sourceImageTitle}
            />
        );

        return imgHtml;
    }

    renderDownloads() {
        let downloads = [],
            iconLink;

        if (this.props.downloadHistory.items.length > 0) {
            this.props.downloadHistory.items.forEach(download => {
                let actionMenu = this.renderActionMenu(download);

                let nameAndId, isActive, detailPath, thumbnailURL;
                if (download.icon) {
                    nameAndId = `${download.icon.name} #${download.icon.id}`;
                    isActive = download.icon.isActive;
                    detailPath = `/icon/${download.icon.id}/`;
                    thumbnailURL = download.icon.thumbnail;
                } else if (download.photo) {
                    nameAndId = `${download.photo.title} #${download.photo.id}`;
                    isActive = download.photo.active;
                    detailPath = `/photo/${download.photo.slugWithId}/`;
                    thumbnailURL = require("../../img/features/icon_history/photo.svg");
                } else {
                    throw new Error("No icon or photo found");
                }

                let rowClasses = ["row", "data"];
                if (download.icon !== null || download.photo !== null) {
                    let detailLink;
                    if (isActive) {
                        detailLink = (
                            <a
                                href={detailPath}
                                style={{ textDecoration: "underline" }}
                                title={`View ${nameAndId}`}
                            >
                                {nameAndId}
                            </a>
                        );
                    } else {
                        detailLink = (
                            <span title="This icon is no longer available">
                                {nameAndId}
                            </span>
                        );
                    }

                    downloads.push(
                        <tr key={download.id} className={rowClasses.join(" ")}>
                            <td
                                className="col-xs-3"
                                title={format(
                                    new Date(download.downloadDate),
                                    "MMM DD, YYYY hh:mm:ss a"
                                )}
                                style={{ textTransform: "uppercase" }}
                            >
                                {this.renderUseSource(download.downloadType)}
                                {format(
                                    new Date(download.downloadDate),
                                    "MM/DD/YY"
                                )}
                            </td>
                            <td
                                className="col-xs-4 icon-name"
                                style={{ position: "relative" }}
                            >
                                <span className="downloaded-icon-container">
                                    <img
                                        src={thumbnailURL}
                                        style={{
                                            width: "24px",
                                            height: "24px",
                                            marginRight: "10px",
                                            cursor: "zoom"
                                        }}
                                    />
                                    <span className="downloaded-icon-zoom">
                                        <img
                                            src={thumbnailURL}
                                            style={{
                                                width: "200px",
                                                height: "200px"
                                            }}
                                        />
                                    </span>
                                </span>
                                {detailLink}
                            </td>
                            <td className="col-xs-4">
                                {this.downloadType(download)}
                            </td>
                            <td
                                className="col-xs-2"
                                style={{
                                    position: "relative",
                                    textAlign: "right",
                                    cursor: "pointer"
                                }}
                                className="view-more-link"
                                onClick={this.showActionMenu.bind(
                                    this,
                                    download.id
                                )}
                            >
                                <span data-download={download.id}>
                                    <span
                                        className="ui_more"
                                        title="view more"
                                    />
                                </span>
                                {actionMenu}
                            </td>
                        </tr>
                    );
                } else {
                    downloads.push(
                        <tr key={download.id} className={rowClasses.join(" ")}>
                            <td
                                className="col-xs-3"
                                title={format(
                                    new Date(download.downloadDate),
                                    "MMM DD, YYYY"
                                )}
                                style={{ textTransform: "uppercase" }}
                            >
                                {this.renderUseSource(download.downloadType)}
                                {format(
                                    new Date(download.downloadDate),
                                    "MM/DD/YY"
                                )}
                            </td>
                            <td>This icon no longer exists.</td>
                            <td />
                            <td />
                        </tr>
                    );
                }
            });
        } else {
            downloads.push(
                <tr key="no-results" className="row data">
                    <td>
                        There is nothing to show yet. Every icon you use will
                        show up in this list.
                    </td>
                </tr>
            );
        }

        return downloads;
    }

    renderPageLinks() {
        let lastPage = Math.ceil(
                this.props.downloadHistory.totalCount / ITEMS_PER_PAGE
            ),
            pageNumbers = [];

        if (this.props.downloadHistory.totalCount > ITEMS_PER_PAGE) {
            let currentPage = 1,
                page = (this.offset + ITEMS_PER_PAGE) / ITEMS_PER_PAGE,
                maxPages = Math.ceil(
                    this.props.downloadHistory.totalCount / ITEMS_PER_PAGE
                ),
                totalPages = maxPages;

            if (page <= 6) {
                if (maxPages > 6) {
                    totalPages = 6;
                }

                while (currentPage <= totalPages) {
                    pageNumbers.push(
                        <li key={currentPage}>
                            <a
                                href="#"
                                onClick={this.goToPage.bind(this, currentPage)}
                                className={page === currentPage ? "active" : ""}
                            >
                                {currentPage}
                            </a>
                            {currentPage !== maxPages ? "," : ""}
                        </li>
                    );
                    currentPage = currentPage + 1;
                }

                if (maxPages > 6) {
                    pageNumbers.push(<li key={8}>{"..."}</li>);
                    pageNumbers.push(
                        <li key={9}>
                            <a
                                href="#"
                                onClick={this.goToPage.bind(this, lastPage)}
                                className={page === lastPage ? "active" : ""}
                            >
                                {lastPage}
                            </a>
                        </li>
                    );
                }
            } else if (page > lastPage - 6) {
                pageNumbers = [
                    <li key={1}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, 1)}
                            className={page === 1 ? "active" : ""}
                        >
                            1
                        </a>
                        {","}
                    </li>,
                    <li key={2}>{"..."}</li>,
                    <li key={3}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, lastPage - 5)}
                            className={page === lastPage - 5 ? "active" : ""}
                        >
                            {lastPage - 5}
                        </a>
                        {","}
                    </li>,
                    <li key={4}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, lastPage - 4)}
                            className={page === lastPage - 4 ? "active" : ""}
                        >
                            {lastPage - 4}
                        </a>
                        {","}
                    </li>,
                    <li key={5}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, lastPage - 3)}
                            className={page === lastPage - 3 ? "active" : ""}
                        >
                            {lastPage - 3}
                        </a>
                        {","}
                    </li>,
                    <li key={6}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, lastPage - 2)}
                            className={page === lastPage - 2 ? "active" : ""}
                        >
                            {lastPage - 2}
                        </a>
                        {","}
                    </li>,
                    <li key={7}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, lastPage - 1)}
                            className={page === lastPage - 1 ? "active" : ""}
                        >
                            {lastPage - 1}
                        </a>
                        {","}
                    </li>,
                    <li key={8}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, lastPage)}
                            className={page === lastPage ? "active" : ""}
                        >
                            {lastPage}
                        </a>
                    </li>
                ];
            } else {
                pageNumbers = [
                    <li key={1}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, 1)}
                            className={page === 1 ? "active" : ""}
                        >
                            1
                        </a>
                        {","}
                    </li>,
                    <li key={2}>{"..."}</li>,
                    <li key={3}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(
                                this,
                                (this.offset + 100) / 100
                            )}
                            className="active"
                        >
                            {(this.offset + 100) / 100}
                        </a>
                        {","}
                    </li>,
                    <li key={4}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(
                                this,
                                (this.offset + 200) / 100
                            )}
                        >
                            {(this.offset + 200) / 100}
                        </a>
                        {","}
                    </li>,
                    <li key={5}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(
                                this,
                                (this.offset + 300) / 100
                            )}
                        >
                            {(this.offset + 300) / 100}
                        </a>
                        {","}
                    </li>,
                    <li key={6}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(
                                this,
                                (this.offset + 400) / 100
                            )}
                        >
                            {(this.offset + 400) / 100}
                        </a>
                        {","}
                    </li>,
                    <li key={7}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(
                                this,
                                (this.offset + 500) / 100
                            )}
                        >
                            {(this.offset + 500) / 100}
                        </a>
                        {","}
                    </li>,
                    <li key={8}>{"..."}</li>,
                    <li key={9}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, lastPage)}
                            className={page === lastPage ? "active" : ""}
                        >
                            {lastPage}
                        </a>
                    </li>
                ];
            }
        }
        return pageNumbers;
    }

    renderPagination() {
        let page = (this.offset + ITEMS_PER_PAGE) / ITEMS_PER_PAGE,
            pageLinks = this.renderPageLinks(),
            pagination,
            totalPages = Math.ceil(
                this.props.downloadHistory.totalCount / ITEMS_PER_PAGE
            ),
            totalShowCount = this.renderTotalShowCount();

        if (page <= totalPages) {
            pagination = (
                <div className="table-pagination-container padding-t-xl">
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center"
                        }}
                    >
                        <div
                            className={`table-list_arrow left-arrow ui_left-arrow ${
                                page === 1 ? "disabled" : ""
                            }`}
                            onClick={this.showPrevious.bind(this)}
                        />
                        <ul
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                margin: "0 20px"
                            }}
                            className="pagination-links"
                        >
                            {pageLinks}
                        </ul>
                        <div
                            className={`table-list_arrow right-arrow ui_right-arrow ${
                                page === totalPages ? "disabled" : ""
                            }`}
                            onClick={this.showNext.bind(this)}
                        />
                    </div>
                    <div
                        className="weight-light"
                        style={{
                            margin: "0 auto",
                            width: "200px",
                            textAlign: "center",
                            color: "#bababa"
                        }}
                    >
                        {totalShowCount}
                    </div>
                </div>
            );
        }

        return pagination;
    }

    showActionMenu(downloadId, e) {
        this.setState({ showDownloadId: downloadId });
    }

    showPrevious() {
        this.offset = this.offset - 100;
        this.props.loadMoreDownloads(this.offset);
    }

    showNext() {
        this.offset = this.offset + 100;
        this.props.loadMoreDownloads(this.offset);
    }

    renderTotalShowCount() {
        let page = (this.offset + ITEMS_PER_PAGE) / ITEMS_PER_PAGE,
            iconsPerPage = this.offset + 100,
            totalCount = this.props.downloadHistory.totalCount,
            totalPages = Math.ceil(
                this.props.downloadHistory.totalCount / ITEMS_PER_PAGE
            ),
            totalShowCount;

        if (iconsPerPage > 0) {
            iconsPerPage = iconsPerPage - 99;
        }

        totalShowCount = (
            <span>
                Showing {number_with_commas(iconsPerPage)} -{" "}
                {page === totalPages
                    ? number_with_commas(totalCount)
                    : number_with_commas(iconsPerPage + 99)}{" "}
                of {` ${number_with_commas(totalCount)}`}
            </span>
        );

        return (
            <div style={{ margin: "0 auto", width: "200px" }}>
                {totalShowCount}
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let creator,
        user = state.user;

    if (state.creator.keys) {
        creator = state.creator[state.creator.keys[0]];
    }

    let { username } = ownProps.match.params;

    return { creator, user, username };
}

function findUsername() {
    // With this old component graphQL code I cant really get this.props.match.username from the DownloadHistory component props
    // Since this code is going to be rewritten anyway I'm just going to extract it from the URL for now
    const url = window.location.href;
    const matchArray =
        url.match(/com\/(.*)\/settings\/icon-history/g) ||
        url.match(/8080\/(.*)\/settings\/icon-history/g);
    return matchArray.length
        ? matchArray[0]
              .replace("com/", "")
              .replace("8080/", "")
              .replace("/settings/icon-history", "")
        : "";
}

const FEED_QUERY = gql`
    query downloadHistory($limit: Int, $offset: Int, $username: String) {
        downloadHistory(limit: $limit, offset: $offset, username: $username) {
            totalCount
            items {
                id
                downloadDate
                downloadType
                icon {
                    isActive
                    id
                    licenseId
                    name: title
                    thumbnail
                }
                photo {
                    id
                    slugWithId
                    title
                    active
                }
            }
        }
    }
`;

const FeedWithData = graphql(FEED_QUERY, {
    options(props) {
        return {
            variables: {
                offset: 0,
                limit: ITEMS_PER_PAGE,
                username: findUsername()
            },
            client: apolloClient
        };
    },
    props({ data: { loading, downloadHistory, currentUser, fetchMore } }) {
        return {
            loading,
            downloadHistory,
            currentUser,
            loadMoreDownloads(offset) {
                return fetchMore({
                    variables: {
                        offset: offset
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        return {
                            downloadHistory: Object.assign(
                                {},
                                previousResult.downloadHistory,
                                {
                                    items: fetchMoreResult.downloadHistory.items
                                }
                            )
                        };
                    }
                });
            }
        };
    }
})(DownloadHistory);

export default connect(mapStateToProps, {
    getCurrentUser: actions.getCurrentUser
})(FeedWithData);
